import type { FC } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: FC = () => {
  const { pathname } = useLocation();

  // Some browsers will use scroll position from previous page when going to a new.
  // Might use this later, right now we try to always have exactly one screen length
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
